import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ConnectToChannelManuallyPopup } from './ConnectToChannelManuallyPopup';

export const CONNECT_CHANNEL_MANUALLY_POPUP = Symbol('CONNECT_CHANNEL_MANUALLY');

export const useConnectToChannelManuallyPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CONNECT_CHANNEL_MANUALLY_POPUP, ConnectToChannelManuallyPopup);
  });

  return useCallback(
    ({ channel }) => {
      return new Promise((resolve) => {
        popups.openPopup(CONNECT_CHANNEL_MANUALLY_POPUP, {
          onSubmit: (data) => {
            popups.closePopup(CONNECT_CHANNEL_MANUALLY_POPUP);
            resolve(data);
          },
          onCancel: () => {
            resolve(null);
            popups.closePopup(CONNECT_CHANNEL_MANUALLY_POPUP);
          },
          channel,
        });
      });
    },
    [popups]
  );
};
